export default {
	INGREDIENT_VARIATION_OPTIONS: 'Ingredient Variations Options',
};
